module.exports = __webpack_public_path__ + "img/V0-bg.e79856e6.png";